import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExpandAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#999" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#999"
        d="m8 12.7 2.534-2.533a.583.583 0 0 1 .85 0 .583.583 0 0 1 0 .85L8.85 13.55q-.35.35-.85.35t-.85-.35l-2.533-2.533a.55.55 0 0 1-.175-.425.62.62 0 0 1 .192-.425.583.583 0 0 1 .85 0zm0-9.4L5.467 5.833a.583.583 0 0 1-.85 0 .583.583 0 0 1 0-.85L7.15 2.45Q7.5 2.1 8 2.1t.85.35l2.534 2.533a.57.57 0 0 1 .183.417.57.57 0 0 1-.183.417.583.583 0 0 1-.85 0z"
      />
    </g>
  </svg>
);
export default SvgExpandAll;
